import React from "react";
import SideMenuShared from "./SideMenuShared";

const SideMenuNew = () => <SideMenuShared variant="desktop" />;

export default SideMenuNew;
